import { render, staticRenderFns } from "./AvatarCrud.vue?vue&type=template&id=04b31868&scoped=true&"
import script from "./AvatarCrud.vue?vue&type=script&lang=js&"
export * from "./AvatarCrud.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCrud.vue?vue&type=style&index=0&id=04b31868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b31868",
  null
  
)

export default component.exports